import React from 'react'
import _ from 'lodash'
import Slider from 'react-slick'
import SliderSettings from '~/tools/slickSliderSettings'

import TrayItem from './trayItem'

import 'slick-carousel/slick/slick.css'
import './style.css'

class ArticleTray extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      items: _.get(props.data, 'contentData') || []
    }
  }

  render() {
    const settings = this.props.layout.settings
    const columns = settings.columns || {}
    const hasMultipleItems = this.state.items && (this.state.items.length > columns.desktop)
    const sliderSettings = new SliderSettings(columns)

    return (
      <div
        className={`article-tray ${settings.thumbnailType ? settings.thumbnailType : ''}`}
      >
        <div className="tray-header">{this.props.data.title}</div>
        <div className="items site-color">
          { this.state.items && this.state.items.length > 0 &&
            <Slider
              dots={false}
              infinite={settings.loop}
              arrows={hasMultipleItems}
              slidesToShow={ sliderSettings.slidesToShow }
              slidesToScroll={ sliderSettings.slidesToScroll }
              responsive={ sliderSettings.responsiveBreakpoints } >
              { this.state.items.map((item, i) => (
                <div key={i}>
                  <TrayItem
                    item={item}
                    sharing={true}
                  />
                </div>
              )) }
            </Slider>
          }
        </div>
      </div>
    )
  }
}

export default ArticleTray
